export const authConstants = {
    LOGIN_REQUEST: "LOGIN_REQUEST",
    LOGIN_FAILURE: "LOGIN_FAILURE",
    LOGIN_SUCCESS: "LOGIN_SUCCESS",
    LOGOUT_REQUEST: "LOGOUT_REQUEST",
    LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
    LOGOUT_FAILURE: "LOGOUT_FAILURE",
  };
  
  export const userContants = {
    USER_REGISTER_REQUEST: "USER_REGISTER_REQUEST",
    USER_REGISTER_SUCCESS: "USER_REGISTER_SUCCESS",
    USER_REGISTER_FAILURE: "USER_REGISTER_FAILURE",
  };
  export const Customers = {
    GET_ALL_CUSTOMERS: "GET_ALL_Customers",
    GET_ALL_CUSTOMERS_SUCCESS : "GET_ALL_CUSTOMERS_SUCCESS" ,
    GET_ALL_CUSTOMERS_FAILED : "GET_ALL_CUSTOMERS_FAILED",
    GET_ALL_CUSTOMERS_FAILED : "GET_ALL_CUSTOMERS_FAILED",
    GET_CUSTOMER: "GET_CUSTOMER",
    GET_CUSTOMER_SUCCESS: "GET_CUSTOMER_SUCCESS",
    GET_CUSTOMER_FAILED: "GET_CUSTOMER_FAILED",
    DELETE_CUSTOMER: "DELETE_CUSTOMER",
    DELETE_CUSTOMER_SUCCESS :"DELETE_CUSTOMER_SUCCESS",
    DELETE_CUSTOMER_FAILED :"DELETE_CUSTOMER_FAILED",
    LOGOUT_CUSTOMERS:"LOGOUT_CUSTOMERS"
  };


  
  export const categoryConstansts = {
    GET_ALL_CATEGORIES_REQUEST: "GET_ALL_CATEGORIES_REQUEST",
    GET_ALL_CATEGORIES_SUCCESS: "GET_ALL_CATEGORIES_SUCCESS",
    GET_ALL_CATEGORIES_FAILURE: "GET_ALL_CATEGORIES_FAILURE",
    ADD_NEW_CATEGORY_REQUEST: "ADD_NEW_CATEGORY_REQUEST",
    ADD_NEW_CATEGORY_SUCCESS: "ADD_NEW_CATEGORY_SUCCESS",
    ADD_NEW_CATEGORY_FAILURE: "ADD_NEW_CATEGORY_FAILURE",
    ADD_NEW_BENEFIT_REQUEST: "ADD_NEW_BENEFIT_REQUEST",
    ADD_NEW_BENEFIT_SUCCESS: "ADD_NEW_BENEFIT_SUCCESS",
    ADD_NEW_BENEFIT_FAILURE: "ADD_NEW_BENEFIT_FAILURE",
    UPDATE_CATEGORIES_REQUEST: "UPDATE_CATEGORIES_REQUEST",
    UPDATE_CATEGORIES_SUCCESS: "UPDATE_CATEGORIES_SUCCESS",
    UPDATE_CATEGORIES_FAILURE: "UPDATE_CATEGORIES_FAILURE",
    DELETE_CATEGORIES_REQUEST: "DELETE_CATEGORIES_REQUEST",
    DELETE_CATEGORIES_SUCCESS: "DELETE_CATEGORIES_SUCCESS",
    DELETE_CATEGORIES_FAILURE: "DELETE_CATEGORIES_FAILURE",
  };


    export const withdrawableConstants = {
    GET_ALL_WITHDRAWABLE_REQUEST: "GET_ALL_WITHDRAWABLE_REQUEST",
    GET_ALL_WITHDRAWABLE_SUCCESS: "GET_ALL_WITHDRAWABLE_SUCCESS",
    GET_ALL_WITHDRAWABLE_FAILURE: "GET_ALL_WITHDRAWABLE_FAILURE",
    UPDATE_WITHDRAWABLE_REQUEST: "UPDATE_WITHDRAWABLE_REQUEST",
    UPDATE_WITHDRAWABLE_SUCCESS: "UPDATE_WITHDRAWABLE_SUCCESS",
    UPDATE_WITHDRAWABLE_FAILURE: "UPDATE_WITHDRAWABLE_FAILURE",
    LOGOUT_WITHDRAWABLE : "LOGOUT_WITHDRAWABLE" 
  };
  
  
  
  export const productConstants = {
    GET_ALL_PRODUCTS_REQUEST: "GET_ALL_PRODUCTS_REQUEST",
    GET_ALL_PRODUCTS_SUCCESS: "GET_ALL_PRODUCTS_SUCCESS",
    GET_ALL_PRODUCTS_FAILURE: "GET_ALL_PRODUCTS_FAILURE",
  
    DELETE_PRODUCT_BY_ID_REQUEST: "DELETE_PRODUCT_BY_ID_REQUEST",
    DELETE_PRODUCT_BY_ID_SUCCESS: "DELETE_PRODUCT_BY_ID_SUCCESS",
    DELETE_PRODUCT_BY_ID_FAILURE: "DELETE_PRODUCT_BY_ID_FAILURE",

    UPDATE_PRODUCT_BY_ID_REQUEST: "UPDATE_PRODUCT_BY_ID_REQUEST",
    UPDATE_PRODUCT_BY_ID_SUCCESS: "UPDATE_PRODUCT_BY_ID_SUCCESS",
    UPDATE_PRODUCT_BY_ID_FAILURE: "UPDATE_PRODUCT_BY_ID_FAILURE",

  
    GET_PRODUCT_REQUEST: "GET_PRODUCT_REQUEST",
    GET_PRODUCT_SUCCESS: "GET_PRODUCT_REQUEST",
    GET_PRODUCT_FAILURE: "GET_PRODUCT_FAILURE",
    LOGOUT_PRODUCT : "LOGOUT_PRODUCT"
  };
  
  export const initialDataConstants = {
    GET_ALL_INITIAL_DATA_REQUEST: "GET_ALL_INITIAL_DATA_REQUEST",
    GET_ALL_INITIAL_DATA_SUCCESS: "GET_ALL_INITIAL_DATA_SUCCESS",
    GET_ALL_INITIAL_DATA_FAILURE: "GET_ALL_INITIAL_DATA_FAILURE",
  };
  
  export const pageConstants = {
    GET_ALL_PAGES: "GET_ALL_PAGES",
    GET_ALL_PAGES_SUCCESS : "GET_ALL_PAGES_SUCCESS" ,
    GET_ALL_PAGES_FAILED : "GET_ALL_PAGES_FAILED",
    GET_ALL_PAGES_FAILED : "GET_ALL_PAGES_FAILED",
    CREATE_PAGE_REQUEST: "CREATE_PAGE_REQUEST",
    CREATE_PAGE_SUCCESS: "CREATE_PAGE_SUCCESS",
    CREATE_PAGE_FAILURE: "CREATE_PAGE_FAILURE",
    DELETE_PAGE_REQUEST: "DELETE_PAGE_REQUEST",
    DELETE_PAGE_SUCCESS: "DELETE_PAGE_SUCCESS",
    DELETE_PAGE_FAILURE: "DELETE_PAGE_FAILURE",
  };
  export const SellersConstants = {
    GET_ALL_SELLERS: "GET_ALL_SELLERS",
    GET_ALL_SELLERS_SUCCESS : "GET_ALL_SELLERS_SUCCESS" ,
    GET_ALL_SELLERS_FAILED : "GET_ALL_SELLERS_FAILED",
    GET_ALL_SELLERS_FAILED : "GET_ALL_SELLERS_FAILED",
    GET_SELLER: "GET_SELLER",
    GET_SELLER_SUCCESS: "GET_SELLER_SUCCESS",
    GET_SELLER_FAILED: "GET_SELLER_FAILED",
    DELETE_SELLER_REQUEST: "DELETE_SELLER_REQUEST",
    DELETE_SELLER_SUCCESS: "DELETE_SELLER_SUCCESS",
    DELETE_SELLER_FAILURE: "DELETE_SELLER_FAILURE",
    LOGOUT_SELLERS : "LOGOUT_SELLERS"

  };
  
  export const orderConstants = {
    GET_CUSTOMER_ORDER_REQUEST: "GET_CUSTOMER_ORDER_REQUEST",
    GET_CUSTOMER_ORDER_SUCCESS: "GET_CUSTOMER_ORDER_SUCCESS",
    GET_CUSTOMER_ORDER_FAILURE: "GET_CUSTOMER_ORDER_FAILURE",
    UPDATE_CUSTOMER_ORDER_REQUEST: "UPDATE_CUSTOMER_ORDER_REQUEST",
    UPDATE_CUSTOMER_ORDER_SUCCESS: "UPDATE_CUSTOMER_ORDER_SUCCESS",
    UPDATE_CUSTOMER_ORDER_FAILURE: "UPDATE_CUSTOMER_ORDER_FAILURE",
    LOGOUT_ORDERS : "LOGOUT_ORDERS"

  };